import { InputSwitch } from "primereact/inputswitch"
import { FC, useState } from "react"
import { ProveedoresHerbaceo } from "./ProveedoresHerbaceo/ProveedoresHerbaceo"
import { ProveedoresLenhoso } from "./ProveedoresLenhoso/ProveedoresLenhoso"
import { GiPlantRoots, GiWoodPile } from "react-icons/gi"
import { HonestWeekPicker } from "../../Scenario/Settings/InformacionGeneral/WeekPicker/WeekPicker"
import { WeekPicker } from "./WeekPicker/WeekPicker"

export const Proveedores:FC<any> = (props):JSX.Element => {

    const {proveedores, setProveedores,proveedoresMASTER,setProveedoresMASTER, flagWeek, setFlagWeek, date, setDate, week, setWeek,changesFlag, setChangesFlag, id, flagChangeScenario, setFlagChangeScenario, tabID} = props

    const [herbaceo, setHerbaceo] = useState<boolean>(false)

    const [prov, setProv] = useState<boolean>(false)

    const onChange = (week:number) => {
        setWeek(week)
        
    }

    return (
        <div className="entregas__wrapper" style={{justifyContent:'flex-end',position:'relative'}}>
            <div className="trucks__switch_container">
                <GiPlantRoots title={"Herbáceo"} style={!herbaceo? {fontWeight:'bold',borderBottom:'1px solid black'} : {}} size={20} />
                <InputSwitch  checked={herbaceo} onChange={(e:any) => setHerbaceo(e.value)} />
                <GiWoodPile  style={herbaceo? {fontWeight:'bold',borderBottom:'1px solid black'} : {}} title={"Leñoso"} size={20} />
            </div>
            <div style={{display:'flex',justifyContent:'space-around',alignItems:'center',fontFamily:'var(--roboto-medium)',fontSize:'0.8rem',overflow:'initial'}}>
                <span style={{marginRight:'1rem'}}>Semana seleccionada: </span><WeekPicker flagWeek={flagWeek} setFlagWeek={setFlagWeek} date={date} setDate={setDate} week={week} setWeek={setWeek}  onChange={onChange}   />
            </div>
            <div className="table__switch_container">
                <span style={!prov? {borderBottom:'1px solid black'}:{}}>Entregas Proveedores</span>
                <InputSwitch  checked={prov} onChange={(e:any) => setProv(e.value)} />
                <span style={prov? {borderBottom:'1px solid black'}:{}}>Entregas Propio</span>
            </div>
            {
                !herbaceo?
                    <ProveedoresHerbaceo
                        proveedores={prov}
                        data={proveedores?.herbaceo}
                        setData={setProveedores}
                        dataMASTER={proveedoresMASTER?.herbaceo}
                        fullData={proveedoresMASTER}
                        setDataMASTER={setProveedoresMASTER}
                        changesFlag={changesFlag}
                        setChangesFlag={setChangesFlag}
                        flagChangeScenario={flagChangeScenario}
                        setFlagChangeScenario={setFlagChangeScenario}
                        id={id}
                        tabID={tabID}
                        />
                :
                    <ProveedoresLenhoso 
                        proveedores={prov}
                        data={proveedores?.lenhoso}
                        setData={setProveedores}
                        dataMASTER={proveedoresMASTER?.lenhoso}
                        fullData={proveedoresMASTER}
                        setDataMASTER={setProveedoresMASTER}
                        changesFlag={changesFlag}
                        setChangesFlag={setChangesFlag}
                        flagChangeScenario={flagChangeScenario}
                        setFlagChangeScenario={setFlagChangeScenario}
                        id={id}
                        tabID={tabID}
                        />
            }
        </div>
    )
}